/**
 * Login 画面: ログインと会員登録モーダルの制御。
 *
 * URL クエリに応じたモーダル表示、メール/パスワードでのログイン、
 * メール認証未完了時の確認メール送信、パスワードリセット送信などを扱います。
 */
import React, {useState, useEffect} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from '../img/logo.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Container } from 'react-bootstrap';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import RegistrationModal from '../components/RegistrationModal';
// history は使用しないため削除

/**
 * ログインページコンポーネント。
 *
 * - URLクエリ(`view`)で、会員登録/処理中/ログイン処理中の各モーダル表示を切り替えます。
 * - メール/パスワードログイン、メール確認未完了時の確認メール送信、
 *   パスワードリセット送信などを提供します。
 *
 * @component
 */
export default function Login(props) { 
  const appVersion = process.env.REACT_APP_APP_VERSION || ''
  const envLabel = process.env.REACT_APP_ENV_LABEL || ''
  const navigate = useNavigate();
  const location = useLocation();
  let Params = new URLSearchParams(location.search) // URLクエリを使用する
  let ModalShow = false
  let ModalRegistProcessShow = false
  let ModalLoginProcessShow = false

  if (Params.get("view") === "Regist") { //URLが「/Login?view=Regist」の場合は会員登録画面表示を行う。
    ModalShow = true  //会員登録画面をモーダルで表示する
  } else {
    ModalShow = false //会員登録画面は非表示とする。（ログイン画面を表示）
  }
  if (Params.get("view") === "Regist_Process") { //URLが「/Login?view=Regist_Process」の場合は会員登録処理中表示を行う。
    ModalRegistProcessShow = true  //会員登録処理中画面をモーダルで表示する
  } else {
    ModalRegistProcessShow = false //会員登録処理中画面を非表示にする
  }
  if (Params.get("view") === "Login_Process") { //URLが「/Login?view=Login_Process」の場合はログイン処理中表示を行う。
    ModalLoginProcessShow = true  //ログイン処理中画面をモーダルで表示する
  } else {
    ModalLoginProcessShow = false //ログイン処理中画面を非表示にする
  }

  const [ modalShow,                     setModalShow                     ] = useState(ModalShow)              //ユーザー新規登録画面の表示コントロール（true=会員登録画面、false=ログイン画面）
  const [ modalRegistProcessShow,        setModalRegistProcessShow        ] = useState(ModalRegistProcessShow) //ユーザー新規登録処理中画面の表示コントロール（true=処理中画面、false=ログイン画面）
  const [ modalLoginProcessShow,         setModalLoginProcessShow         ] = useState(ModalLoginProcessShow)  //ログイン処理中画面の表示コントロール（true=ログイン中画面、false=ログイン画面）
  // const [ ,                               setIsLogin                       ] = useState(false)                  //ログイン状態（値は参照しない）
  const [ loginEmailValue,               setLoginEmailValue               ] = useState('')                     //ユーザーのメールアドレス
  const [ loginPasswordValue,            setLoginPasswordValue            ] = useState('')                     //ユーザーのパスワード
  // const [ loginEmailAlertText,           setLoginEmailAlertText           ] = useState()                       //ログインメールアドレス警告文字列（未使用のためコメントアウト）

  /**
   * モーダル種別に応じてページタイトルを設定する副作用。
   * `modalShow`/`modalRegistProcessShow`/`modalLoginProcessShow` の変更で反映します。
   */
  useEffect(() => {
    if (modalShow === true) {
      document.title = '会員登録 - ふぁみかるくん'
    } else if (modalRegistProcessShow === true) {
      document.title = '会員登録処理中 - ふぁみかるくん'
    } else if (modalLoginProcessShow === true) {
      document.title = 'ログイン処理中 - ふぁみかるくん'
    } else {
      document.title = 'ログイン - ふぁみかるくん'
    }
  }, [modalShow, modalRegistProcessShow, modalLoginProcessShow])

  /**
   * アンマウント時にページタイトルを初期化する副作用。
   */
  useEffect(() => {
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);

  //ログイン画面表示時は、エラー防止のため、１回だけ画面の再読み込みを行う。
  // 強制リロードは副作用が大きいため撤廃

  /**
   * メールアドレス/パスワードでログインし、状態に応じて遷移します。
   *
   * 挙動:
   * - ログイン処理中モーダルを表示し、事前にサインアウト。
   * - 認証成功後、メール未確認なら確認メールを送信し Login に戻る。
   * - Firestore `Person/{uid}` から最初の `FamilyID` を取得し、`FamilyHome/:FamilyID` へ遷移。
   * - 失敗時はエラーコードに応じてアラート表示し、処理中モーダルを閉じる。
   *
   * @async
   * @function handleEmailLogin
   * @returns {Promise<void>} 遷移のみを行い、値は返しません
   */
  const handleEmailLogin = async () => {
    try {
      //ログイン処理中画面に移動
      setModalShow(false) //会員登録画面のモーダルを非表示にする
      setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
      setModalLoginProcessShow(true) //ログイン中画面のモーダルを表示にする
      navigate('/Login?view=Login_Process')

      await firebase.auth().signOut() //ユーザーのサインアウトを行う。
      // setIsLogin(false)

      const result = await firebase.auth().signInWithEmailAndPassword(loginEmailValue, loginPasswordValue)
      const user = result.user
      console.log('user.email:', user.email)
      console.log('user.uid:', user.uid)

      if (!user.emailVerified) {
        console.log('Do verify email. user.emailVerified:', user.emailVerified)
        const continueUrl = window.location.origin + '/'
        const actionCodeSettings = {
          url: continueUrl,
          handleCodeInApp: false,
        }
        await firebase.auth().currentUser.sendEmailVerification(actionCodeSettings)
        alert('メールアドレス確認用のメールをお送りしました。\n送信先アドレス：' + user.email)
        setModalLoginProcessShow(false)
        navigate('/Login')
        return
      }

      const personSnap = await firebase.firestore().collection('Person').doc(user.uid).get()
      if (!personSnap.exists) {
        alert('アカウント情報が見つかりません。サポートへお問い合わせください。')
        setModalLoginProcessShow(false)
        return
      }
      const data = personSnap.data()
      const firstFamily = data && Array.isArray(data.FamilyID) ? data.FamilyID[0] : undefined
      if (!firstFamily || !firstFamily.id) {
        alert('家族情報が未設定です。サポートへお問い合わせください。')
        setModalLoginProcessShow(false)
        return
      }
      // setIsLogin(true)
      navigate('/FamilyHome/' + firstFamily.id)
    } catch (error) {
      console.log('ログインに失敗しました。\n code:', error.code, '\n message:', error.message)
      if (error.code === 'auth/user-not-found') {
        alert('ログインに失敗しました。\nアカウントは存在しません。')
      } else if (error.code === 'auth/invalid-email') {
        alert('ログインに失敗しました。\n正しいメールアドレスを入力してください。')
      } else if (error.code === 'auth/wrong-password') {
        alert('ログインに失敗しました。\nパスワードを確認してください')
      } else if (error.code === 'auth/user-disabled') {
        alert('ログインに失敗しました。\nサービスは無効化されています。')
      } else if (error.code === 'auth/too-many-requests') {
        alert('短時間に多数の試行がありました。時間をおいて再試行してください。')
      } else {
        alert('ログインに失敗しました。')
      }
      setModalShow(false) //会員登録画面のモーダルを非表示にする
      setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
      setModalLoginProcessShow(false) //ログイン中画面のモーダルを非表示にする
    }
  }

  /**
   * ログイン・新規作成用メールアドレスの入力値を更新します。
   * @param {React.ChangeEvent<HTMLInputElement>} e 入力イベント
   * @returns {void}
   */
  const handleLoginEmailChange = (e) => {
    setLoginEmailValue(e.target.value)
  }

  //新規作成用メールアドレス入力から離れた際にチェックする
  // 未使用のため削除（メール形式チェックを再度使う場合は onBlur に直接実装）

  /**
   * ログイン・新規作成用パスワードの入力値を更新します。
   * @param {React.ChangeEvent<HTMLInputElement>} e 入力イベント
   * @returns {void}
   */
  const handleLoginPasswordChange = (e) => {
    setLoginPasswordValue(e.target.value)
  }
  
  /**
   * パスワードを忘れた場合の処理（パスワード再設定メール送信）。
   *
   * Firebase Auth の `sendPasswordResetEmail` を利用し、
   * 成否に応じてアラート表示を行います。
   *
   * @function handleSendPasswordResetEmail
   * @returns {void}
   */
  const handleSendPasswordResetEmail = () => {
    console.log("handleSendPasswordResetEmail")
    Promise.resolve()
    .then(() => {
      const continueUrl = window.location.origin + '/'
      var actionCodeSettings = {
        url: continueUrl, //メールアドレス認証後に開くURLを指定する
        handleCodeInApp: false,         //Webサイトとして開く設定
      }
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(loginEmailValue, actionCodeSettings)
        .then(() => {
          alert('パスワードリセットメールを送信しました。\n送信先アドレス：' + loginEmailValue)
          resolve()
        })
        .catch((error) => {
          if (error.code === "auth/invalid-email" && error.message === "The email address is badly formatted.") {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n送信先メールアドレスの形式が正しくありません。\n送信先アドレス：' + loginEmailValue)
          } else if (error.code === "auth/user-not-found" && error.message === "There is no user record corresponding to this identifier. The user may have been deleted.") {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n対象のアカウントが存在しません。\n送信先アドレス：' + loginEmailValue)
          } else {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n送信先アドレス：' + loginEmailValue)
          }

          reject()
        })
      })
    })
    .then(() => {
      //パスワードリセットメール送信時の処理
      console.log("パスワードリセットメールを送信しました。")
    })
    .catch(() => {
      //パスワードリセットメール送信失敗時の処理
      console.log("パスワードリセットメールを送信に失敗しました。")
    })
  }

  /**
   * 会員登録完了時の後処理。モーダルを全て閉じて Login へ遷移します。
   * @function handleRegistrationComplete
   * @returns {void}
   */
  const handleRegistrationComplete = () => {
    // 登録完了後、ログイン画面に遷移
    setModalShow(false);
    setModalRegistProcessShow(false);
    setModalLoginProcessShow(false);
    // setIsLogin(false);
    navigate('/Login');
  };

  return (
    <div>
      <ul style={{ display: 'flex', justifyContent: 'center', padding: '0px' }}>
        <div className="justify-md-center align-Center">
          <Link to='/'><img src={logo} alt="ふぁみかるくんロゴ" /></Link>

          {/* ログイン用メールアドレス、パスワード入力画面 */}
          <div>
            <Form onSubmit={(e) => handleEmailLogin(e)}>
              <Form.Group controlId="formLoginEmail">
                <Form.Label>Eメールアドレス</Form.Label>
                <Form.Control type="email" placeholder="Eメールアドレスを入力ください" name="formLoginEmail"
                  value={loginEmailValue} onChange={(e) => handleLoginEmailChange(e)} />
                <Form.Text className="text-muted">　　　　　　　　　　　　　　　　　　　　　　　</Form.Text>
              </Form.Group>

              <Form.Group controlId="formLoginPassword">
                <Form.Label>パスワード</Form.Label>
                <Form.Control type="password" placeholder="パスワードを入力ください" name="formLoginPassword"
                  value={loginPasswordValue} onChange={(e) => handleLoginPasswordChange(e)} />
              </Form.Group>
            </Form>
          </div>

          {/* パスワードを忘れた場合はこちら */}
          <div>
            <Button
              variant="link"
              onClick={() => handleSendPasswordResetEmail()}
            >
              パスワードを忘れた場合はこちら
            </Button>
          </div>

          {/* 「ログイン」ボタン */}
          <button type="button" className="nav-link btn btn-primary text-center col-md" style={{margin: "0.4em auto", width: "calc(100% - 60px)", padding: "5px 0px"}} onClick={() => handleEmailLogin()} >
            ログイン
          </button>

          {/* 「会員登録」ボタン */}
          <button type="button" className="nav-link btn btn-primary text-center col-md" style={{margin: "0.8em auto", width: "calc(100% - 60px)", padding: "5px 0px"}}
            onClick={() => {
              document.title = `会員登録 - ふぁみかるくん${envLabel}`
              setModalShow(true)
              navigate('/Login?view=Regist')
            }}>
            会員登録
          </button>
          <div style={{margin: "0.2em auto", padding: "0px"}}><a href="https://famikar.jp/privacy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a></div>
          <div style={{margin: "0.2em auto", padding: "0px"}}><a href="https://famikar.jp" target="_blank" rel="noopener noreferrer">ふぁみかるくん　サービスページ</a></div>
          <div style={{margin: "1.3em auto 0.2em", padding: "0px"}}>運営元：<a href="https://gometo.co.jp/" target="_blank" rel="noopener noreferrer">株式会社GoMeTo</a></div>
          <div style={{margin: "0.2em auto", padding: "0px", color: '#888'}}>{`ふぁみかるくん Ver.${appVersion}${envLabel}`}</div>

          {/* 会員登録モーダル */}
          <RegistrationModal
            show={modalShow}
            onHide={() => {
              setModalShow(false);
              navigate('/Login');
            }}
            email={loginEmailValue}
            isInvitation={false}
            onRegistrationComplete={handleRegistrationComplete}
          />

          {/* 処理中画面（modal） */}
          <Modal show={modalRegistProcessShow}>
            <Modal.Header>
              <Modal.Title>会員登録 - 処理中</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <div style={{margin: '7em 0'}}>
                  会員登録処理中<br />
                  画面を閉じないでください。
                </div>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              
            </Modal.Footer>
          </Modal>

          {/* ログイン中画面（modal） */}
          <Modal show={modalLoginProcessShow}>
            <Modal.Header>
              <Modal.Title>ログイン - 処理中</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <div style={{margin: '7em 0'}}>
                  ログイン処理中<br />
                  画面を閉じないでください。
                </div>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              
            </Modal.Footer>
          </Modal>
        </div>
      </ul>
    </div>
  )
}
